<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div>
    <template v-if="currentViewBaked === 'loading'">
      <b-loading
        is-full-page
        :active.sync="isLoading"
      >
        <div class="box loading">
          <div class="bloader">
            <div class="shape shape-1" />
            <div class="shape shape-2" />
            <div class="shape shape-3" />
            <div class="shape shape-4" />
          </div>
        </div>
      </b-loading>
    </template>
    <div
      v-if="currentViewBaked === 'baked'"
      id="page"
      class="container"
      :class="languageAbbrSelected"
    >
      <div class="box reload_note">
        <div class="reload_note_container">
          <i class="fas fa-sync" />
          <span class="reload_note_text">
            {{ $t("index.reload") }}
          </span>
        </div>
      </div>

      <div class="box results">
        <center>
          <div class="quiz_ready_title">
            <h4>{{ $t("index.congrats") }}</h4>
            <h2>{{ $t("index.ready") }}<span>{{ $t("index.live") }}</span></h2>
            <h3>{{ $t("index.goshare") }}</h3>
          </div>
        </center>

        <div class="quiz_link_container">
          <h4 id="results_quiz_link_title">
            {{ $t("index.quizlink") }}
          </h4>

          <input
            id="pollLinkField"
            v-model="quizLinkComp"
            type="text"
            size="35"
            class="highlighted_text"
            name="pollLinkField"
            readonly=""
          >

          <button
            id="copyButton"
            class="fullWidthButton button_2 pushdown"
            @click="copy_link()"
          >
            {{ $t("index.copylink") }}
          </button>
          <!-- <div class="copy_status_container"> -->
          <p
            v-if="display"
            id="status"
          >
            {{ $t("index.copied") }}
          </p>
          <!-- </div> -->
        </div>

        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button instagram_button"
              @click="show_how(1)"
            >
              <i class="fab fa-instagram" />
              <span
                id="instagram_share_button_text"
                class="share_text"
              >
                {{ $t("index.instagram") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button facebook_button"
              @click="goToFacebook()"
            >
              <i class="fab fa-facebook-f" />
              <span
                id="facebook_share_button_text"
                class="share_text"
              >
                {{ $t("index.facebook") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button twitter_button"
              @click="goToTwitter()"
            >
              <i class="fab fa-twitter" />
              <span
                id="twitter_share_button_text"
                class="share_text"
              >
                {{ $t("index.twitter") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button tiktok_button"
              @click="goToTiktok()"
            >
              <i class="fab fa-tiktok" />
              <span
                id="tiktok_share_button_text"
                class="share_text"
              >
                {{ $t("index.tiktok") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button whatsapp_button"
              @click="goToWhatsapp()"
            >
              <i class="fab fa-whatsapp" />
              <span
                id="whatsapp_share_button_text"
                class="share_text"
              >
                {{ $t("index.whatsapp") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button messenger_button"
              @click="goToMessenger()"
            >
              <i class="fab fa-facebook-messenger" />
              <span
                id="messenger_share_button_text"
                class="share_text"
              >
                {{ $t("index.messenger") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button whatsapp_button"
              @click="show_how(2)"
            >
              <i class="fab fa-whatsapp" />
              <span
                id="whatsapp_status_share_button_text"
                class="share_text"
              >
                {{ $t("index.whatsappstatus") }}
              </span>
            </a>
          </div>
        </div>
        <div class="share_button_container">
          <div class="share_button_div">
            <a
              class="share_button snapchat_button last-in-box"
              @click="show_how(3)"
            >
              <i class="fab fa-snapchat-ghost" />
              <span
                id="snapchat_share_button_text"
                class="share_text"
              >
                {{ $t("index.snapchat") }}
              </span>
            </a>
          </div>
        </div>
      </div> <!-- closing div.box.results -->

      <h4 id="results_note">
        {{ $t("index.browsernote") }}
      </h4>
      <div class="done_button_shadow">
        <button
          id="view_results_button_text"
          class="fullWidthButton button_2 pushdown"
          type="button"
          @click="go_to_results()"
        >
          {{ $t("index.seeresults") }}
        </button>
      </div>

      <!-- <div id="ad_baked_1"></div> -->

      <div class="delete_button_shadow">
        <button
          id="delete_button_text"
          class="fullWidthButton button_2 pushdown"
          type="button"
          @click="deleteQuiz()"
        >
          {{ $t("index.deletebutton") }}
        </button>
      </div>

      <!-- Root element of PhotoSwipe. Must have class pswp. -->
      <div
        class="pswp"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div class="pswp__bg" />
        <div class="pswp__scroll-wrap">
          <div class="pswp__container">
            <div class="pswp__item" />
            <div class="pswp__item" />
            <div class="pswp__item" />
          </div>
          <div class="pswp__ui pswp__ui--hidden">
            <div class="pswp__top-bar">
              <div class="pswp__counter" />
              <button
                class="pswp__button pswp__button--close"
                title="Close (Esc)"
              />
              <button
                class="pswp__button pswp__button--share"
                title="Share"
              />
              <button
                class="pswp__button pswp__button--fs"
                title="Toggle fullscreen"
              />
              <button
                class="pswp__button pswp__button--zoom"
                title="Zoom in/out"
              />
              <div class="pswp__preloader">
                <div class="pswp__preloader__icn">
                  <div class="pswp__preloader__cut">
                    <div class="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
            </div>
            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div class="pswp__share-tooltip" />
            </div>
            <button
              class="pswp__button pswp__button--arrow--left"
              title="Previous (arrow left)"
            />
            <button
              class="pswp__button pswp__button--arrow--right"
              title="Next (arrow right)"
            />
            <div class="pswp__caption">
              <div class="pswp__caption__center" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'BakedCompo',
  // eslint-disable-next-line
  props: [ 'quizId', 'currentViewCreation', 'userId', 'languageAbbrSelected' ],
  data () {
    return {
      currentViewBaked: '',
      display: false,
      isLoading: false
      // playwireUnits: [
      //   {
      //     selectorId: 'ad_baked_1',
      //     type: 'leaderboard_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ],
      // tyched: false
    }
  },
  computed: {
    quizLinkComp: function () {
      return 'https://bestiefy.com/q?=' + this.quizId
    }
  },
  watch: {
    currentViewCreation: function () {
      this.currentViewBaked = cloneDeep(this.currentViewCreation)
    }
  },
  // updated () {
  //   if (this.currentViewBaked === 'baked' && !this.tyched) {
  //     this.initTyche()
  //     this.tyched = true
  //   }
  // },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API@Baked is initialized')
    //   try {
    //     ramp.destroyUnits('all')
    //   } catch (e) {
    //     console.log('destroyUnits error: ', e)
    //   }
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    copy_link () {
      let _0x2fcax7c
      let _0x2fcax7d
      let linkContainer = document.getElementById('pollLinkField')
      if (this.isOS()) {
        _0x2fcax7c = document.createRange()
        _0x2fcax7c.selectNodeContents(linkContainer)
        _0x2fcax7d = window.getSelection()
        _0x2fcax7d.removeAllRanges()
        _0x2fcax7d.addRange(_0x2fcax7c)
        linkContainer.setSelectionRange(0, 999999)
      } else {
        linkContainer.select()
      };
      document.execCommand('Copy')
      // this.copiedMessage = this.$t('index.copied')
      this.display = true
    },
    isOS () {
      return navigator.userAgent.match(/ipad|iphone/i)
    },
    goToFacebook () {
      window.open('https://facebook.com/sharer.php?u=https://bestiefy.com/q?=' + this.quizId, '_blank')
    },
    goToWhatsapp () {
      let whatsappMessage = this.$t('index.gotowhatsapptwitter')
      window.location.href = 'whatsapp://send?text=' + whatsappMessage + ' https://bestiefy.com/q?=' + this.quizId
    },
    goToMessenger () {
      window.location.href = 'fb-messenger://share/?link=https://bestiefy.com/q?=' + this.quizId
    },
    goToTwitter () {
      let twitterMessage = this.$t('index.gotowhatsapptwitter')
      window.open('https://twitter.com/share?url=https://bestiefy.com/q?=' + this.quizId + '&text=' + twitterMessage, '_blank')
    },
    goToTiktok () {
      // let tiktokMessage = this.$t('index.gotowhatsapptwitter')
      window.open('https://tiktok.com/', '_blank')
    },
    go_to_results () {
      window.location.href = '/q?=' + this.quizId
    },
    // PhotoSwipe
    show_how (_platform) {
      var pswpElement = document.querySelectorAll('.pswp')[0]
      var howinstagram = [
        { src: 'https://webestiefy.com/bestimages/instructions_instagram_1.png',
          w: 360,
          h: 640
        },
        { src: 'https://webestiefy.com/bestimages/instructions_instagram_2.png',
          w: 360,
          h: 640
        }
      ]
      var howwhatsapp = [
        { src: 'https://webestiefy.com/bestimages/instructions_whatsapp_1.png',
          w: 360,
          h: 640
        },
        { src: 'https://webestiefy.com/bestimages/instructions_whatsapp_2.png',
          w: 360,
          h: 640
        }
      ]
      var howsnapchat = [
        { src: 'https://webestiefy.com/bestimages/instructions_snapchat_1.png',
          w: 360,
          h: 640
        },
        { src: 'https://webestiefy.com/bestimages/instructions_snapchat_2.png',
          w: 360,
          h: 640
        }
      ]
      var options = {
        history: false,
        tapToClose: true,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        bgOpacity: 0.7,
        showHideOpacity: true,
        counterEl: false,
        index: 0 // start at first slide
      }
      if (_platform === 1) {
        // eslint-disable-next-line
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, howinstagram, options)
        gallery.init()
      } else if (_platform === 2) {
        // eslint-disable-next-line
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, howwhatsapp, options)
        gallery.init()
      } else if (_platform === 3) {
        // eslint-disable-next-line
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, howsnapchat, options)
        gallery.init()
      } else {}
    },
    // PhotoSwipe END
    deleteQuiz () {
      let confirmationMessage = this.$t('index.deleteconfirm')
      let confirmation = confirm(confirmationMessage)
      if (confirmation === true) {
        this.currentViewBaked = 'loading'
        this.isLoading = true
        this.$http.all([
          this.$http.delete('https://bestiebackend.herokuapp.com/api/quizzes/' + this.quizId),
          this.$http.delete('https://bestiebackend.herokuapp.com/api/users/' + this.userId)
        ])
          .then(response => {
            window.location.reload()
            // console.log(response)
          })
          .catch(error => {
            // console.log(error)
          })
      }
    }

  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box.reload_note {
  background-color: white;
  padding: 18px 25px;
  margin-bottom: 20px;
}
.box.reload_note::after {
    background-color: #F1F2F6;
}
.reload_note_container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.reload_note_container i {
  font-size: 32px;
  color: #2ed59c;
  vertical-align: middle;
  margin-right: 18px;
  flex: 0 0 32px;
}
.reload_note_text{
  flex: 0 1 auto;
  display: flex;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  color: #242933;
  line-height: 18px;
}
</style>
